import React from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Divider from "../Components/Divider";
import SharedComp from "../Components/Camparision/SharedComp";
import CurrencyConverter from "../Components/CurrencyConverter";
import { useGeoLocation } from "../utils/useGeoLocation";
import { FaWifi, FaGlobe, FaThemeco } from "react-icons/fa";
import { BsDeviceSsdFill } from "react-icons/bs";
import { GrDomain } from "react-icons/gr";
import EnhancedSEO from "../Components/EnhancedSEO";
import { 
  generateMetaTags, 
  pageConfigs, 
  generateServiceSchema,
  generateProductSchema,
  generateFAQSchema
} from "../utils/seoUtils";

function SharedHosting() {
  const { 
    userLocation,
    userCurrency 
  } = useGeoLocation();

  // Pricing data for shared hosting plans (base prices in INR)
  const sharedPlans = {
    starter: {
      name: "DAStarter",
      subtitle: "Ideal For Beginners",
      basePrice: 79,
      yearlyPrice: 799,
      features: [
        "Host 1 Website",
        "10GB NVME SSD",
        "Unlimited Bandwidth",
        "Europe & USA Location",
        "Free Astra Pro & Divi Theme"
      ],
      pid: "89",
      popular: false
    },
    pro: {
      name: "DAPRo", 
      subtitle: "Perfect For Professionals",
      basePrice: 109,
      yearlyPrice: 1099,
      features: [
        "Host 10 Website",
        "50GB NVME SSD", 
        "Unlimited Bandwidth",
        "Europe & USA Location",
        "Free Astra Pro & Divi Theme"
      ],
      pid: "90",
      popular: true
    },
    elite: {
      name: "DAElite",
      subtitle: "Optimized For Businesses", 
      basePrice: 149,
      yearlyPrice: 1499,
      features: [
        "1 Free Domain",
        "Host Unlimited Website",
        "100GB NVME SSD",
        "Unlimited Bandwidth", 
        "Europe & USA Location",
        "Free Astra Pro & Divi & Elementor Pro",
      ],
      pid: "91",
      popular: false
    }
  };

  // Enhanced SEO configuration
  const sharedPageConfig = generateMetaTags(pageConfigs.sharedHosting);
  
  // Structured data for shared hosting page
  const sharedStructuredData = [
    generateServiceSchema(
      "Shared Web Hosting Services",
      "Affordable shared web hosting services in India perfect for beginners and small websites with reliable performance and 24/7 support."
    ),
    generateProductSchema(
      "Shared Hosting Plan",
      "Budget-friendly shared hosting with free SSL, unlimited bandwidth, and easy website management",
      "79"
    ),
    generateFAQSchema([
      {
        question: "What is shared web hosting?",
        answer: "Shared web hosting is a hosting service where multiple websites share the same server resources. It's the most affordable hosting option, perfect for beginners and small websites."
      },
      {
        question: "Is shared hosting suitable for my website?",
        answer: "Shared hosting is ideal for personal blogs, small business websites, portfolios, and websites with moderate traffic. It offers great value for money with all essential features."
      },
      {
        question: "Do you provide free SSL with shared hosting?",
        answer: "Yes, we provide free SSL certificates with all our shared hosting plans to ensure your website is secure and trusted by visitors."
      }
    ])
  ];

  return (
    <>
      <EnhancedSEO 
        pageConfig={sharedPageConfig}
        structuredData={sharedStructuredData}
      />
      {/* ======= Hero Section =======  */}

      <section
        className="sharedtop bgsharedhostingimg"
        id="top"
        style={{ color: "black" }}
      >
        <div className="container">
          <div className="row align-items-center py-md-5">
            <div className="col-lg-6 col-12 topseccont">
              <div className="container">
                <span className="sa-bluebg-subhead">
                  👋 Up to 30% off Shared Hosting
                </span>
                <h1 className="sa-hero-h1">
                  Your Home to New Online Beginnings
                </h1>
                <p>
                  Blazing Fast Speed with our litespeed web servers, Low Cost
                  Shared Web Hosting
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Arrow icon"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Unmetered Nvme Disk Space</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Arrow icon"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Lightning Fast Servers</span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Arrow icon"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>24/7 Technical Support</span>
                </div>
                <br />
                {/* <ul className="topseclist">
                  <li>
                    <i aria-hidden="true" className="fa fa-check-square-o"></i>
                    Unmetered Disk Space
                  </li>
                  <li>
                    <i aria-hidden="true" className="fa fa-check-square-o"></i>
                    Lightning Fast India Servers
                  </li>
                  <li>
                    <i aria-hidden="true" className="fa fa-check-square-o"></i>24x7
                    Technical Support
                  </li>
                </ul> */}
                <a href="#pricing" className="btn btn-primary">
                  View Plans
                </a>
                {/* <p className="topsecstrt">
                  Starts at <span>Rs.59/mo</span>
                </p> */}
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img
                // src="../assets/img/shared-1.png"
                src="https://res.cloudinary.com/clubhosty/image/upload/v1713575325/bendy-woman-web-designer-creating-landing-page_kum7k9.svg"
                alt="imges"
                className="img-fluid bounce-img shared-hero-img"
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Hero  */}
      <main id="main">
        <section id="pricing" className="pricing section-bg">
          <div className="container">
            <div className="section-title">
              <h3>Choose a Perfect Plan That's Right For You.</h3>
              <p>
                <span>Shared hosting</span> with the best unlimited features,
                free CDN & fast speed!
              </p>
              {/* Location-based pricing info */}
              {userLocation && (
                <div className="pricing-location-info" style={{
                  backgroundColor: '#e6f9fa',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  marginTop: '20px',
                  border: '1px solid #b3ecef',
                  textAlign: 'center'
                }}>
                  <p style={{ 
                    color: '#21bcc3', 
                    fontSize: '14px', 
                    margin: '0',
                    fontWeight: '500'
                  }}>
                    <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i> 
                    Pricing shown in {userCurrency} for {userLocation.country}
                  </p>
                </div>
              )}
            </div>

            <div className="row tabingcustome">
              <div className="col-12">
                <ul
                  className="nav nav-pills mb-3 justify-content-center"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active first-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-inr"
                      type="button"
                      role="tab"
                      aria-controls="pills-inr"
                      aria-selected="true"
                    >
                      Monthly
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link last-button"
                      id="pills-usd-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-usd"
                      type="button"
                      role="tab"
                      aria-controls="pills-usd"
                      aria-selected="false"
                    >
                      Yearly
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
              {/* Monthly Plans */}
              <div
                className="tab-pane fade show active"
                id="pills-inr"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div className="row">
                  {Object.entries(sharedPlans).map(([key, plan]) => (
                    <div key={key} className="col-md-4" data-aos-delay="100">
                      <div className={`box sharedbox ${plan.popular ? 'featured' : ''}`}>
                        <div className="pricing-head">
                          {plan.popular && <span className="advanced">Featured</span>}
                          <p>{plan.name}</p>
                          <p className="subprichead">{plan.subtitle}</p>

                          <h4 style={{
                            background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}>
                            <CurrencyConverter 
                              priceINR={plan.basePrice} 
                            />
                            <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                          </h4>

                          <div className="btn-wrap mt-3">
                            <a
                              href={`http://my.clubhosty.com/cart.php?a=add&pid=${plan.pid}&billingcycle=monthly`}
                              className="btn-buy"
                            >
                              Buy Now
                            </a>
                          </div>
                        </div>
                        <ul>
                          {plan.features.map((feature, index) => {
                            const getFeatureIcon = () => {
                              if (feature.includes('Website')) return <FaGlobe />;
                              if (feature.includes('SSD')) return <BsDeviceSsdFill />;
                              if (feature.includes('Bandwidth')) return <FaWifi />;
                              if (feature.includes('Theme') || feature.includes('Pro')) return <FaThemeco />;
                              if (feature.includes('Domain')) return <GrDomain />;
                              return <FaGlobe />;
                            };
                            
                            const getFeatureText = () => {
                              if (feature.includes('Free') && (feature.includes('Theme') || feature.includes('Pro'))) {
                                return <><b style={{ color: "red" }}>Free</b> {feature.replace('Free ', '')}</>;
                              }
                              if (feature.includes('1 Free Domain')) {
                                return <><b>1 Free</b> Domain</>;
                              }
                              // Bold the important parts
                              if (feature.includes('Host')) {
                                const parts = feature.split(' ');
                                return <><b>{parts.slice(0, 2).join(' ')}</b> {parts.slice(2).join(' ')}</>;
                              }
                              if (feature.includes('GB') || feature.includes('Unlimited')) {
                                const parts = feature.split(' ');
                                return <><b>{parts[0]}</b> {parts.slice(1).join(' ')}</>;
                              }
                              return <b>{feature}</b>;
                            };
                              
                            return (
                              <li key={index}>
                                <span>{getFeatureIcon()}</span>
                                {getFeatureText()}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-usd"
                role="tabpanel"
                aria-labelledby="pills-usd-tab"
              >
                <div className="row">
                  {Object.entries(sharedPlans).map(([key, plan]) => (
                    <div key={key} className="col-md-4" data-aos-delay="100">
                      <div className={`box sharedbox ${plan.popular ? 'featured' : ''}`}>
                        <div className="pricing-head">
                          {plan.popular && <span className="advanced">Featured</span>}
                          <p>{plan.name}</p>
                          <p className="subprichead">{plan.subtitle}</p>

                          <h4 style={{
                            background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}>
                            <CurrencyConverter 
                              priceINR={plan.yearlyPrice} 
                            />
                            <span style={{ fontSize: '16px', opacity: '0.9' }}> / Year</span>
                          </h4>

                          <div className="btn-wrap mt-3">
                            <a
                              href={`http://my.clubhosty.com/cart.php?a=add&pid=${plan.pid}&billingcycle=annually`}
                              className="btn-buy"
                            >
                              Buy Now
                            </a>
                          </div>
                        </div>
                        <ul>
                          {plan.features.map((feature, index) => {
                            const getFeatureIcon = () => {
                              if (feature.includes('Website')) return <FaGlobe />;
                              if (feature.includes('SSD')) return <BsDeviceSsdFill />;
                              if (feature.includes('Bandwidth')) return <FaWifi />;
                              if (feature.includes('Theme') || feature.includes('Pro')) return <FaThemeco />;
                              if (feature.includes('Domain')) return <GrDomain />;
                              return <FaGlobe />;
                            };
                            
                            const getFeatureText = () => {
                              if (feature.includes('Free') && (feature.includes('Theme') || feature.includes('Pro'))) {
                                return <><b style={{ color: "red" }}>Free</b> {feature.replace('Free ', '')}</>;
                              }
                              if (feature.includes('1 Free Domain')) {
                                return <><b>1 Free</b> Domain</>;
                              }
                              // Bold the important parts
                              if (feature.includes('Host')) {
                                const parts = feature.split(' ');
                                return <><b>{parts.slice(0, 2).join(' ')}</b> {parts.slice(2).join(' ')}</>;
                              }
                              if (feature.includes('GB') || feature.includes('Unlimited')) {
                                const parts = feature.split(' ');
                                return <><b>{parts[0]}</b> {parts.slice(1).join(' ')}</>;
                              }
                              return <b>{feature}</b>;
                            };
                              
                            return (
                              <li key={index}>
                                <span>{getFeatureIcon()}</span>
                                {getFeatureText()}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <SharedComp />
        {/* ======= Shared Benifits =======  */}
        <section className="hostbeni">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h2>The Benefits of Using ClubHosty Shared Web Hosting</h2>
                  <p>
                    We utilize top-of-the-line servers to power our Shared Web
                    Hosting plans. Each server is optimized for speed and
                    limited to how many clients can operate on each server. This
                    powerful combination of resources, performance enhancements,
                    and limited occupancy means an industry-leading web hosting
                    experience, with 20X faster page load times, at a low cost
                    to you. Want even more performance? Consider a Turbo Plan
                    which comes with 40% faster CPU performance, 3X faster NVMe
                    storage, and advanced Litespeed Turbo Caching. Already have
                    a website hosted somewhere else? Our Guru Support will
                    migrate it ClubHosty for FREE!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Shared Bentfits  */}
        {/* ======= Services Section =======  */}
        <section className="services" id="services">
          <div className="container">
            <div className="section-title">
              <h2>Services</h2>
              <h3>
                Experience The <span>ClubHosty</span> Difference
              </h3>
            </div>
            <div className="row">
              <div className="col-md-3" data-aos-delay="100">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bxl-dribbble"></i>
                  </div>
                  <h4>
                    <Link to="">Up To 20X Faster Turbo</Link>
                  </h4>
                  <p>
                    That means better SEO rankings, lower bounce rates & higher
                    conversion rates!
                  </p>
                </div>
              </div>
              <div className="col-md-3" data-aos-delay="200">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-file"></i>
                  </div>
                  <h4>
                    <Link to="">Best Guru Crew Support</Link>
                  </h4>
                  <p>
                    Our friendly and knowledgeable support team is available
                    24/7/365 to help!
                  </p>
                </div>
              </div>
              <div className="col-md-3" data-aos-delay="300">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <Link to="">Free Account Migration</Link>
                  </h4>
                  <p>
                    Our team can move your site to ClubHosty Hosting for free in
                    most cases!
                  </p>
                </div>
              </div>
              <div className="col-md-3" data-aos-delay="100">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-world"></i>
                  </div>
                  <h4>
                    <Link to="">Money-Back Guarantee</Link>
                  </h4>
                  <p>
                    Give our high speed hosting service a try completely
                    risk-free!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
        {/* ======= Featured Services Section =======  */}
        <section
          id="featured-services"
          className="featured-services section-bg"
          style={{ padding: "60px 0px" }}
        >
          <div className="container">
            <div className="section-title" style={{ textAlign: "center", marginBottom: "4px" }}>
              <h2>Why Choose ClubHosty?</h2>
              <p><strong>SHARED HOSTING BUNDLED WITH EXCEPTIONAL FEATURES</strong></p>
              <p style={{ textAlign: 'center' }}>Let your blog or website get the top-notch performance they deserve with ClubHosty's features that exceeds your expectations.</p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837436/certificate_pvnibx.png"
                      alt="Free SSL Certificate"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Free SSL Certificate</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Every online shopper is concerned about online security. An SSL certificate on your website, builds trust for anyone visiting your website. With our cheap shared hosting plans, you get a Let's Encrypt SSL certificate without any additional cost.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837720/builder_ti6v50.png"
                      alt="Free Site Builder"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Free Site Builder</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    With our in-built site builder tool, build your own professional website. Simply choose your template from thousands of free templates available and launch your site in a jiff. The process is quite simple, just drag and drop your content and images and there you go!
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837797/storage_evxltu.png"
                      alt="SSD NVMe Storage"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">SSD NVMe Storage</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    We tailor the needs for your business or personal website by providing SSD NVMe-based best shared hosting service in India. Maximize your website's performance by hosting your website at ClubHosty' server. With our SSD NVMe based servers, you get up 200% faster-performing websites.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837881/secure-email_nzsami.png"
                      alt="Secure Email Accounts"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Secure Email Accounts</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Get quick and easy access to your email with secured POP3/ IMAP. You can access your emails at any time and from anywhere with the availability of webmail. This webmail gives you access to three webmail clients: Horde, SquirrelMail, and RoundCube.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837946/php-mysql_jozchq.png"
                      alt="Latest PHP & MySQL"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Latest PHP & MySQL</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    With shared web hosting plans, we offer you everything that you need to get started with your website. Our web servers are ready with the most stable and the most compatible versions of PHP & MySQL.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838027/click-installer_mjuuoz.png"
                      alt="1-Click Installer"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">1-Click Installer</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Softaculous, 1-click installer enables you to install over 400 applications like WordPress, Joomla, Drupal, etc. The tool is integrated into control panel offered with Cpanel hosting plans.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Services Section  */}
        {/* ======= About Section =======  */}
        <section 
          id="about" 
          className="about section-bg" 
          style={{ 
            backgroundColor: "#ffffff", 
            padding: "80px 0",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos-delay="100">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  position: "relative",
                  height: "100%"
                }}>
                  <img
                    src="https://res.cloudinary.com/clubhosty/image/upload/v1713574383/slide-1_clgocy.png"
                    alt="Client Interface Management"
                    style={{ 
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      filter: "hue-rotate(338deg) saturate(1.2)"
                    }}
                  />
                </div>
              </div>
              
              <div className="col-lg-6" data-aos-delay="200">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                  <h2 style={{ 
                    color: "#333", 
                    fontSize: "36px", 
                    fontWeight: "600", 
                    lineHeight: "1.2", 
                    marginBottom: "20px",
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    Awesome client interfaces to build and manage your sites easily
                  </h2>
                  
                  <p style={{ 
                    color: "#666", 
                    fontSize: "16px", 
                    lineHeight: "1.6", 
                    marginBottom: "30px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "500"
                  }}>
                    Take a look at how easy and intuitive it is to create sites and manage them with the wide range of tools we offer. We help you get your business online. From domain names to affordable hosting plans, get everything you need to set up your website.
                  </p>
                  
                  <button 
                    onClick={() => {
                      const pricingSection = document.getElementById('pricing');
                      if (pricingSection) {
                        pricingSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    style={{ 
                      background: "#21bcc3",
                      border: "none",
                      color: "#fff",
                      padding: "15px 30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(33, 188, 195, 0.3)",
                      transition: "all 0.3s ease",
                      fontFamily: "'Poppins', sans-serif",
                      alignSelf: "flex-start"
                    }}>
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <style jsx>{`
            .about button:hover {
              transform: translateY(-2px);
              background: #20bfc0;
              box-shadow: 0 6px 20px rgba(33, 188, 195, 0.4);
            }
          `}</style>
        </section>
        {/* End About Section  */}
        {/* ======= Featured Services Section =======  */}
        {/* <section id="featured-services" className="featured-services">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="100">
                  <div className="icon">
                    <i className="fa fa-desktop"></i>
                  </div>
                  <h4 className="title">
                    <Link to="">Direct Admin</Link>
                  </h4>
                  <p className="description">
                    World's no 1 hosting control panel with nice user interface.
                    Cron schedulling , seo tools, customize php versions.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="200">
                  <div className="icon">
                    <i className="fa fa-hdd-o"></i>
                  </div>
                  <h4 className="title">
                    <Link to="">NVME SSD</Link>
                  </h4>
                  <p className="description">
                    SSD (Solid state drives) and HDD (Hard disk drive) both
                    functionally same but SSD Drives 20x Faster.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="300">
                  <div className="icon">
                    <i className="fa fa-refresh"></i>
                  </div>
                  <h4 className="title">
                    <Link to="">Secure Backups</Link>
                  </h4>
                  <p className="description">
                    Never lose your website’s data while you host your website
                    at our server Free Of Cost.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* End Featured Services Section  */}
        <section id="about" className="about">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            {/* <p style={{ padding: "10px" }}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
            <Divider />
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is a shared hosting website?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Shared web hosting is a service in which multiple websites
                    are hosted on the same server. In simple words, server
                    resources are distributed to multiple customers to cut down
                    the server cost.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is the benefit of shared web hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    There are multiple benefits of shared web hosting that makes
                    it the most popular choice, especially among the initial
                    bloggers. Here are some of them mentioned below:
                  </p>

                  <li>Very budget friendly</li>
                  <li>Easy to avail</li>
                  <li>Instant setup</li>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Is shared hosting good for blogs?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes….! Those bloggers who are at the initial stage of their
                    journey can start with Shared web hosting to set up a
                    website and understand everything in detail.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Does Shared web hosting include free domain names?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes…..! We offer a free domain (.com ) with our annual plans
                    that you can easily avail without paying any extra charges.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I migrate my website to your shared web hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes….! We offer free migration you can avail to transfer
                    your website from your existing service providers to our
                    quality services if you are not comfortable with their
                    services.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
      </main>
      {/* End #main  */}

      {/* Custom Styles for Geolocation Features */}
      <style jsx>{`
        .pricing-location-info {
          background: linear-gradient(135deg, #f8fdff 0%, #e8f8f9 100%);
          padding: 10px 15px;
          border-radius: 8px;
          border-left: 4px solid #21bcc3;
          text-align: center;
          margin: 15px auto;
          max-width: 600px;
        }

        /* Loading states */
        .loading-placeholder {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 20px;
          width: 100px;
        }

        @keyframes loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        /* Mobile optimizations */
        @media (max-width: 768px) {
          .pricing-location-info {
            padding: 8px 12px;
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
}

export default SharedHosting;
